import { themeVars } from '../theme/vars';
import { borderRadius, space } from '../tokens';
import { typography } from '../typography';
import { globalStyle, style, styleVariants } from '../layer.css';

export const inputVariants = styleVariants({
  default: {
    outline: `1px solid ${themeVars.controls.border.default}`,
  },
  error: {
    outline: `1px solid ${themeVars.controls.border.critical}`,
  },
});

export const inputContainer = style([
  typography['bodyMd'],
  {
    display: 'flex',
    alignItems: 'center',
    gap: space.s12,

    borderRadius: borderRadius.r8,

    color: themeVars.controls.foreground.input,

    height: '40px',
    overflow: 'hidden',

    outlineOffset: -1,
    backgroundColor: themeVars.controls.background.default,

    ':hover': {
      outlineColor: themeVars.controls.border.hover,
    },
    ':focus-within': {
      outlineColor: themeVars.controls.border.active,
    },

    selectors: {
      '&[data-disabled]': {
        pointerEvents: 'none',
        backgroundColor: themeVars.controls.background.disabled,
        color: themeVars.controls.foreground.disabled,
        outline: 'none',
      },
    },
  },
]);

globalStyle(`.${inputContainer} svg`, {
  color: themeVars.controls.foreground.default,
  flexShrink: 0,
});
globalStyle(`.${inputContainer}:where(:focus-within, [data-has-value]) svg`, {
  color: themeVars.controls.foreground.input,
});
globalStyle(`.${inputContainer}[data-disabled] svg`, {
  color: themeVars.controls.foreground.disabled,
});

export const inputContainerWithBefore = style({
  paddingLeft: space.s16,
});

export const inputContainerWithAfter = style({
  paddingRight: space.s16,
});

export const input = style({
  backgroundColor: 'unset',
  height: '100%',
  border: 0,
  padding: `${space.s8}px ${space.s16}px`,
  outline: 'none',
  flexGrow: 1,
  minWidth: 0,

  '::placeholder': {
    color: themeVars.controls.foreground.default,
  },

  selectors: {
    [`${inputContainerWithBefore} &`]: {
      paddingLeft: 0,
    },
    [`${inputContainerWithAfter} &`]: {
      paddingRight: 0,
    },
    [`&:disabled::placeholder`]: {
      color: themeVars.controls.foreground.disabled,
    },
  },
});

export const inputCharacterCount = style({
  color: themeVars.container.foreground.tertiary,
});

export const inputError = style([
  typography.bodySm,
  {
    color: themeVars.container.foreground.critical,
    marginTop: space.s4,
  },
]);

export const inputLabel = style([
  typography.labelSm,
  {
    display: 'flex',
    alignItems: 'center',
    gap: space.s4,
    color: themeVars.controls.foreground.label,
    marginBottom: space.s4,
  },
]);

export const inputOptional = style({
  color: themeVars.container.foreground.tertiary,
});

export const labelWithHintContainer = style({
  marginLeft: space.s4,
});
